import { exists } from "../../../../api/ux/src/runtime";
export var AssetClass;
(function (AssetClass) {
    AssetClass["INFRA"] = "INFRA";
    AssetClass["PE"] = "PE";
    AssetClass["PD"] = "PD";
    AssetClass["RE"] = "RE";
    AssetClass["SEC"] = "SEC";
    AssetClass["ALL"] = "ALL";
})(AssetClass || (AssetClass = {}));
export const assetClassFromJSON = (json) => json;
// Parser for GET /fundSeries/{id}
export const fundSeriesFromJSON = (json) => ({
    assetClasses: exists(json, "assetClasses") ? json.assetClasses.map(assetClassFromJSON) : [],
    currency: exists(json, "currency") ? json.currency : undefined,
    dateUploaded: exists(json, "dateUploaded") ? new Date(json.dateUploaded) : undefined,
    id: exists(json, "id") ? json.id : undefined,
    name: exists(json, "name") ? json.name : undefined,
    referenceDate: exists(json, "referenceDate") ? new Date(json.referenceDate) : undefined
});
// Parser for GET /fundSeries (list)
export const fundSeriesListItemFromJSON = (json) => ({
    asAtDate: exists(json, "asAtDate") ? new Date(json.asAtDate) : undefined,
    assetClass: exists(json, "assetClass") ? json.assetClass : undefined,
    dateUploaded: exists(json, "dateUploaded") ? new Date(json.dateUploaded) : undefined,
    fundManager: exists(json, "fundManager") ? json.fundManager : undefined,
    fundsInSeries: exists(json, "fundsInSeries") ? json.fundsInSeries : undefined,
    id: exists(json, "id") ? json.id : undefined,
    name: exists(json, "name") ? json.name : undefined,
    strategy: exists(json, "strategy") ? json.strategy : undefined
});
